import { Router } from '@angular/router';
import { UntypedFormBuilder, FormControl, FormControlName, UntypedFormGroup, Validators } from '@angular/forms';
import { Component, OnInit, OnDestroy, AfterViewInit } from '@angular/core';
import axios from 'axios';
import { NgxSpinnerService } from 'ngx-spinner';
import { Authenticationservice } from '../../services/authentication.service';
import {Observable} from 'rxjs';
declare var $: any;



@Component({
  selector: 'app-askforfactor6667',
  templateUrl: './askforfactor6667.component.html',
  styleUrls: ['./askforfactor6667.component.css']
})
export class Askforfactor6667Component implements OnInit, OnDestroy, AfterViewInit {

  zone: any;
  usercode: any;
  Formfactor: UntypedFormGroup;
  submitted = false;

  constructor(private spinner: NgxSpinnerService, private auth: Authenticationservice, private fb: UntypedFormBuilder) {
    let userdata: any;
    userdata = this.auth.Authention();
    this.zone = userdata.zonedata;
    this.usercode = userdata.supcode;
    this.goloadfarmerinzone();
    this.goloadstock();

    this.Formfactor = this.fb.group({
      fm: '',
      localstock: '',
      cemecal: '',
      countcemecal: '',
      fertilizer: '',
      countfertilizer: '',
      dolomite: '',
      countdolomite: '',
      medical: '',
      countmedical: '',
      machine: '',
      countmachine: '',
      cash: ''
    });
  }
  ngAfterViewInit(): void {
    $('.select2').select2();
  }

  ngOnInit(): void {
    setTimeout(() => {
      /*this.goloaddolomite();
      this.goloadchemical();
      this.goloadmachine();
      this.goloadmedic();
      this.goloadorganic();*/
      this.goloadstock_data();
    }, 100);

  }
  
 /* select_index_f(){
    document.getElementById("mySelect").selectedIndex = "0";
  }*/

  // โหลดข้อมูล stock ปุ๋ย
  selected = 0;
  fertilizerstock: any[];
  goloadstock() {
    let url='https://asia-southeast2-brr-farmluck.cloudfunctions.net/dbcps/select_StockBRD'
    axios.get(url)
      .then(res => {
        this.fertilizerstock = res.data.recordset;
      }).catch(err => { throw (err) })
  }
  // โหลดข้อมูลชาวไร่ในเขต
  famerlist: any[];
  goloadfarmerinzone() {
    this.spinner.show();
    let url = "https://asia-southeast2-brr-farmluck.cloudfunctions.net/brdsqlapi/select_fmcodeIn_cp6667?supzone=" + this.zone;
    axios.get(url)
      .then(res => {
        this.famerlist = res.data.recordset;
      }).catch(err => { console.log(err); })
    this.spinner.hide();
  }

  ckack(){
    let fmcode = ((<HTMLInputElement>document.getElementById("codefm")).value).slice(1, 11);
    //let fmcode = this.fmcode//this.Formfactor.value.fmcode
    //let takecash = this.Formfactor.get('cash').value;
    let takecash = this.ckcash;    
    var ckfamer = this.famerlist.filter(el => el.fmcode_b1 === fmcode);
    
    if(fmcode == null || fmcode === '') null
    else if ((ckfamer[0].PromiseIN == 0 || ckfamer[0].approve == 'N') && !takecash) {
      alert("ไม่สามารถเบิกได้ค่ะ");
      this.ckfarmercan = true;
    }
    else if (ckfamer[0].zoneban == 'Y' && !takecash) {
      alert("ไม่สามารถเบิกได้ค่ะ เนื่องจากเป็นโซนต้องห้าม");
      this.ckfarmercan = true;
    }
    else {
      this.ckfarmercan = false;
    }
    console.log('ckack-','takecash',takecash,'ckfarmercan',this.ckfarmercan);
    console.log('ckack-',ckfamer,fmcode)
  }

  ckcash=false;
  // โหลดข้อมูลชาวไร่ 1 คน
  dataonefarmer: any;
  ckfarmercan = false;
  goloaddata() {
    let fmcode = ((<HTMLInputElement>document.getElementById("codefm")).value).slice(1, 11);    
    if (fmcode == '') { }    
    else {
      this.ckack();
      if(!this.ckfarmercan){
        this.dataonefarmer = null;
        //  โหลดแปลงชาวไร่
        let url = "https://asia-southeast2-brr-farmluck.cloudfunctions.net/dbcps/select_s_f_w_0?s=*&f=[CPS6263].[dbo].[v_cp6667_getFert12]&w=fmcode='" + fmcode+"'";
        axios.get(url)
          .then(res => {
            this.spinner.show();
            this.dataonefarmer = (res.data);
            this.dataonefarmer.sort((a, b) => {return b.landvalue - a.landvalue;});
            this.spinner.hide();
          }).catch(err => { console.log(err); })
        //this.goloadfertiltzerbyfmcode(fmcode);
        this.Loadaskforfactorlist(fmcode);
        this.ck_sum_money_amt(fmcode);
        this.lodadck_realty_debt(fmcode);   
      }
      
    }
  }
  //  รายการด้านล่าง
  onecode: any[];
  Loadaskforfactorlist(fmcode ='') {
    axios.get("https://asia-southeast2-brr-farmluck.cloudfunctions.net/dbcps/select_s_f_w_0?s=*&f=[CPS6263].[dbo].[v_getfactor6667]&w=[fmcode]='" + fmcode + "'")
      .then(res => {
        this.spinner.show();
        let data = res.data;
        data.sort((a, b) => {
          return new Date(b.datepost).getTime() - new Date(a.datepost).getTime();
        });
        this.onecode = data;
        this.spinner.hide();
      }).catch(err => { console.log(err); })      
  }

  sum_money_amt=0 //วงเงินที่ใช้ไป
  sum_money_amt1=0 //ขอเกี้ยว
  sum_money_amt2=0 //ขอเปิกปัจจัย

  RSUM_long=0 //หนี้คงค้างของปี
  credit=0 //มีวงเงิน
  limit=0 //คงเหลือ

  ck_money_amt_last:any
  ck_sum_money_amt(fmcode: any) {
    axios.get("https://asia-southeast2-brr-farmluck.cloudfunctions.net/dbcps/ck_sum_money_amt_w?yearID=6667&fmcode=" + fmcode )
      .then(res => {
        this.spinner.show();
        this.sum_money_amt = 0;
        this.sum_money_amt1 = 0;
        this.sum_money_amt2 = 0;
        if(res.data.rowsAffected >= 1){
          let data_t = res.data.recordset;
          this.ck_money_amt_last = data_t;
          this.sum_money_amt1 = data_t[0].sum_money_amt1
          this.sum_money_amt2 = data_t[0].sum_money_amt2
          this.sum_money_amt = data_t[0].sum_money_amt
          setTimeout(() => {
            if (this.credit >0 || this.RSUM_long>0)
              this.limit = this.credit - (this.sum_money_amt + this.RSUM_long)            
          }, 100);
        }       
         //console.log('ck_money_amt_last',this.ck_money_amt_last)
        this.spinner.hide();
      }).catch(err => { console.log(err); })     //this.oneplant[0].canetype + ' พื้นที่ ' + this.oneplant[0].landvalue;
  }

  ck_realty_debt:any
  lodadck_realty_debt(fmcode: any) {
    this.spinner.show(); 
    axios.get("https://asia-southeast2-brr-farmluck.cloudfunctions.net/dbbrr/ck_realty_debt?year=6667&fmcode=" + fmcode )
      .then(res => {              
        this.RSUM_long = 0;
        this.credit = 0;
        if(res.data.rowsAffected >= 1){ 
          this.spinner.hide();
          let data = res.data.recordset;
          this.ck_realty_debt = data
          this.RSUM_long = data[0].RSUM_long_66
          this.credit = data[0].guaranter + data[0].sumRealty
          setTimeout(() => {
            if (this.credit >0 || this.RSUM_long>0)
              this.limit = this.credit - (this.sum_money_amt + this.RSUM_long)            
          }, 100);
        }
        //console.log('ck_realty_debt',this.ck_realty_debt)
        this.spinner.hide();
      }).catch(err => { console.log(err); })      
  } 
  clearFm(){
    this.fmcode = '';
    this.oneplant = [];
    this.dataonefarmer = null;
  }

  /*//  โหลดข้อมูลปุ๋ยในแปลง
  ferplantdata: any;
  goloadfertiltzerbyfmcode(fmcode) {
    let url = "https://asia-southeast2-brr-farmluck.cloudfunctions.net/brdsqlapi/select_v_cp6566_basic_aw?fmcode='" + fmcode + "'";
    axios.get(url)
      .then(res => {
        this.ferplantdata = res.data.recordset;
      }).catch(err => { console.log(err); })
  }*/

  stock_data: any;
  stock_d1:any;  stock_d2:any;  stock_d3:any;  stock_d4:any;  stock_d5:any;
  goloadstock_data() {
    this.spinner.show();
    let url = "https://asia-southeast2-brr-farmluck.cloudfunctions.net/dbcps/select_s_f_w_0?s=stock_id,description,amt_in,amt_out,CntUnitMsr,group_type,per_unit&f=[dbo].[stock]&w=[amt_in]>0or[amt_out]>0";
    axios.get(url)
      .then(res => {
        this.stock_data = res.data;
        this.stock_d1 = this.stock_data.filter((el:any)=> el.group_type === '1'); 
        this.stock_d2 = this.stock_data.filter((el:any)=> el.group_type === '2');
        this.stock_d3 = this.stock_data.filter((el:any)=> el.group_type === '3');
        this.stock_d4 = this.stock_data.filter((el:any)=> el.group_type === '4');
        this.stock_d5 = this.stock_data.filter((el:any)=> el.group_type === '5');
        /*
        console.log('stock_data',this.stock_data);    
        console.log('stock1',this.stock_d1);   console.log('stock2',this.stock_d2);
        console.log('stock3',this.stock_d3);   console.log('stock4',this.stock_d4);
        console.log('stock5',this.stock_d5);
        */
        //this.filtOpt1 = this.myControl.valueChanges.pipe(startWith(''),map(value => this._filter(value)));

      }).catch(err => { console.log(err); })
    this.spinner.hide();
  }

  // เลือก 1 แปลง
  oneplant = [];
  famername: string;
  intlandno: string;
  detailsplant:string
  Selectoneplant(itid) {
    this.oneplant = this.dataonefarmer.filter(el => el.itid === itid);
    console.log('oneplant',this.oneplant);
    this.famername = this.oneplant[0].fmname;
    this.intlandno = this.oneplant[0].intlandno;
    this.detailsplant = this.oneplant[0].canetype + ' พื้นที่ ' + this.oneplant[0].landvalue;
    this.Changetock();    
  }

  main_stock=''
  Changetock(){
    this.main_stock = this.Formfactor.get('localstock').value
    this.Change_amt(0);
    //this.Formfactor.reset('cemecal');
    this.Formfactor.controls['cemecal'].reset()
    this.Formfactor.controls['fertilizer'].reset()
    this.Formfactor.controls['dolomite'].reset()
    this.Formfactor.controls['medical'].reset()
    this.Formfactor.controls['machine'].reset()
    //console.log('main_stock',this.main_stock)  
     this.val_st();
  }

//รหัสสินค้า  //ราคา-หน่วย//      //
  get1=''; amt_1=0; amt_val1=0; amt_last1=0;
  get2=''; amt_2=0; amt_val2=0; amt_last2=0;
  get3=''; amt_3=0; amt_val3=0; amt_last3=0;
  get4=''; amt_4=0; amt_val4=0; amt_last4=0;
  get5=''; amt_5=0; amt_val5=0; amt_last5=0;
  sum_amtlast=0;

  val_st(){
    this.Formfactor.get('cemecal').setValue(['',0,0,0,'']);
    this.Formfactor.get('fertilizer').setValue(['',0,0,0,'']);
    this.Formfactor.get('dolomite').setValue(['',0,0,0,'']);
    this.Formfactor.get('medical').setValue(['',0,0,0,'']);
    this.Formfactor.get('machine').setValue(['',0,0,0,'']);   
    /*setTimeout(() => {
      this.ChangeValue(1);
      this.ChangeValue(2);
      this.ChangeValue(3);
      this.ChangeValue(4);
      this.ChangeValue(5);
    }, 300);*/
    
  }

  cangetcaneOrganic: any;
  name_doc=[,,,,]
  ChangeValue(id: any) {
    this.cangetcaneOrganic = this.oneplant[0].balance_Organic;
    // let lastdata = this.oneplant[0].balance_Organic;
    if (id == 1) {
      let dataval = this.Formfactor.get('cemecal').value;
      this.oneplant[0].caneGetfert12 = (this.oneplant[0].balance_fert12 * parseInt(dataval[1]));
      this.get1===(dataval[0])
      if(this.main_stock=='00')this.amt_1=parseInt(dataval[2]) 
      else this.amt_1=parseInt(dataval[3]) 
      //this.amt_last1=(this.amt_1)*(this.amt_val1)
      if(dataval[0]==='') this.amt_val1 = 0;//$("#countcem").val('0');
      else if(this.amt_val1 > 0) {}
      else this.amt_val1 = 1;//$("#countcem").val('1');
      this.Change_amt(1);
      this.name_doc[0]=dataval[4];
      //console.log('dataval',dataval)
      //console.log('val1',this.get1,this.amt_1,this.amt_val1,this.amt_last1)
    }
    else if (id == 2) {
      let dataval = this.Formfactor.get('fertilizer').value;
      this.cangetcaneOrganic = (this.oneplant[0].balance_Organic * parseInt(dataval[1]))
      this.get2===(dataval[0])
      if(this.main_stock=='00')this.amt_2=parseInt(dataval[2]) 
      else this.amt_2=parseInt(dataval[3]) 
      //this.amt_last2=(this.amt_2)*(this.amt_val2)
      if(dataval[0]==='') this.amt_val2 = 0;
      else if(this.amt_val2 > 0) {}
      else this.amt_val2 = 1;
      this.Change_amt(2);
      this.name_doc[1]=dataval[4];
      //console.log('dataval',dataval)
      //console.log('val2',this.get2,this.amt_2,this.amt_val2,this.amt_last2)
    }
    else if (id == 3) {
      let dataval = this.Formfactor.get('dolomite').value;
      this.get3===(dataval[0])
      if(this.main_stock=='00')this.amt_3=parseInt(dataval[2]) 
      else this.amt_3=parseInt(dataval[3]) 
      //this.amt_last3=(this.amt_3)*(this.amt_val3)
      if(dataval[0]==='') this.amt_val3 = 0;
      else if(this.amt_val3 > 0) {}
      else this.amt_val3 = 1;
      this.Change_amt(3);
      this.name_doc[2]=dataval[4];
      //console.log('dataval',dataval)
      //console.log('val3',this.get3,this.amt_3,this.amt_val3,this.amt_last3)
    }
    else if (id == 4) {
      let dataval = this.Formfactor.get('medical').value;
      this.get4===(dataval[0])      
      if(this.main_stock=='00')this.amt_4=parseInt(dataval[2]) 
      else this.amt_4=parseInt(dataval[3]) 
      //this.amt_last4=(this.amt_4)*(this.amt_val4)
      if(dataval[0]==='') this.amt_val4 = 0;
      else if(this.amt_val4 > 0) {}
      else this.amt_val4 = 1;
      this.Change_amt(4);
      this.name_doc[3]=dataval[4];
      //console.log('dataval',dataval)
      //console.log('val4',this.amt_4,this.amt_4,this.amt_val4,this.amt_last4)
    }
    else if (id == 5) {
      let dataval=[] = this.Formfactor.get('machine').value;
      this.get1===(dataval[0])
      if(this.main_stock=='00')this.amt_5=parseInt(dataval[2]) 
      else this.amt_5=parseInt(dataval[3]) 
      //this.amt_last5=(this.amt_5)*(this.amt_val5)
      if(dataval[0]==='') this.amt_val5 = 0;
      else if(this.amt_val5 > 0) {}
      else this.amt_val5 = 1;
      this.Change_amt(5);
      this.name_doc[4]=dataval[4];
      //console.log('dataval',dataval)
     //console.log('val5',this.get1,this.amt_5,this.amt_val5,this.amt_last5)
    }    
    else ''
    this.sum_amtlast=this.amt_last1+this.amt_last2+this.amt_last3+this.amt_last4+this.amt_last5
    //console.log('main_stock',this.main_stock)

  }
  Change_amt(id: any) {
    // let lastdata = this.oneplant[0].balance_Organic;
    if (id == 0) {
      this.get1='';this.amt_1=0;this.amt_val1=0;this.amt_last1=0;
      this.get2='';this.amt_2=0;this.amt_val2=0;this.amt_last2=0;
      this.get3='';this.amt_3=0;this.amt_val3=0;this.amt_last3=0;
      this.get4='';this.amt_4=0;this.amt_val4=0;this.amt_last4=0;
      this.get5='';this.amt_5=0;this.amt_val5=0;this.amt_last5=0;
      this.name_doc=[,,,,]
      }
    else if (id == 1) {      
      this.amt_last1=(this.amt_1)*(this.amt_val1)
      console.log('val1',this.amt_1,this.amt_val1,this.amt_last1)
    }
    else if (id == 2) {
      this.amt_last2=(this.amt_2)*(this.amt_val2)
      console.log('val2',this.amt_2,this.amt_val2,this.amt_last2)
    }
    else if (id == 3) {
      this.amt_last3=(this.amt_3)*(this.amt_val3)
      console.log('val3',this.amt_3,this.amt_val3,this.amt_last3)
    }
    else if (id == 4) {
      this.amt_last4=(this.amt_4)*(this.amt_val4)
      console.log('val4',this.amt_4,this.amt_val4,this.amt_last4)
    }
    else if (id == 5) {
      this.amt_last5=(this.amt_5)*(this.amt_val5)
      console.log('val5',this.amt_5,this.amt_val5,this.amt_last5)
    }
    else ''
    this.sum_amtlast=this.amt_last1+this.amt_last2+this.amt_last3+this.amt_last4+this.amt_last5;
  }

  //บันทึกข้อมูลเบิกปัจจัย
  Savedatafactor() {
    this.submitted = true;
    let dataIs = this.Formfactor.value
    console.log('dataIs',dataIs)

    let localstock = dataIs.localstock
    
    let cemecal = dataIs.cemecal
    let fertilizer = dataIs.fertilizer
    let dolomite = dataIs.dolomite
    let medical = dataIs.medical//(this.Formfactor.get('medical').value).slice(1, 10);
    let machine = dataIs.machine//(this.Formfactor.get('machine').value).slice(1, 10);

    let countcemecal = this.amt_val1
    let countfertilizer = this.amt_val2
    let countdolomite = this.amt_val3
    let countmedical = this.amt_val4
    let countmachine = this.amt_val5

    //let takecash = this.Formfactor.get('cash').value;
    let takecash = this.ckcash
    let cash = 0;
    /*
    if (medical == '0000-0000') { medical = 0; }
    */
    if (takecash == true) { cash = 1; }
    else { cash = 0;    }
    let url = "https://asia-southeast2-brr-farmluck.cloudfunctions.net/brdsqlapi/insert_getfactorw?supcode='" + this.usercode + "'"
      + "&factor_type=2"
      + "&YearID='6667'"
      + "&doc_status=8"
      // แปลงชาวไร่
      + "&itid=%27" + this.oneplant[0].itid + "%27"
      + "&intlandno=%27" + this.intlandno + "%27"
      + "&fmcode=%27" + this.oneplant[0].fmcode + "%27"
      // แปลงชาวไร่      
      + "&stockid=%27" + localstock.trim() + "%27"
      + "&get1=%27" + cemecal[0] + "%27"
      + "&get2=%27" + fertilizer[0] + "%27"
      + "&get3=%27" + medical[0] + "%27"
      + "&get4=%27" + dolomite[0] + "%27"
      + "&get5=%27" + machine[0] + "%27"
      + "&amt1=" + (countcemecal)
      + "&amt2=" + (countfertilizer)
      + "&amt3=" + (countmedical)
      + "&amt4=" + (countdolomite)
      + "&amt5=" + countmachine
      + "&money_amt=" + this.sum_amtlast
      + "&take_method=" + cash;
     
    if (this.intlandno == undefined || this.intlandno == '' || this.intlandno == null || this.oneplant == undefined || this.oneplant.length == 0) {
      alert("กรุณาเลือกแปลง");
    }
    else if (localstock == undefined || localstock == '' || localstock == null) {
      alert("กรุณาเลือกรายการสต็อค");
    }
    else if (this.sum_amtlast <=0) {
      alert("กรุณาใส่จำนวนที่จะเบิกให้มากกว่า 0");
    }
    else if (cash != 1) {
      if ((countcemecal) > (this.oneplant[0].balance_fert12 * parseInt(cemecal[1]))) {
        alert("ไม่สามารถเบิก ปุ๋ยเคมี ได้เนื่องจากเกินจำนวน");
      }
      /*else if ((countdolomite) > (this.oneplant[0].balance_Dolomite * parseInt(dolomite[1]))) {
        alert("ไม่สามารถเบิก โดโลไมท์ ได้เนื่องจากเกินจำนวน");
        console.log((countdolomite));
      
      else if ((countfertilizer) > (this.oneplant[0].balance_Organic * parseInt(fertilizer[1]))) {
        alert("ไม่สามารถเบิก ปุ๋ยอินทรีย์ ได้เนื่องจากเกินจำนวน");
        console.log(this.oneplant[0].balance_Organic * parseInt(fertilizer[1]));
        console.log((countfertilizer));
      }}*/
     /* else if (this.sum_amtlast > this.limit) {
        alert("ไม่สามารถเบิกได้ เนื่องจากยอดรวม "+this.sum_amtlast+" เกินวงเงินคงเหลือ "+this.limit);        
        console.log('sum_amtlast',this.sum_amtlast,'limit',this.limit);
      } */
      else if (this.sum_amtlast > this.limit) {
        if (confirm("เนื่องจากยอดรวม "+this.sum_amtlast+" เกินวงเงินคงเหลือ "+this.limit+" ต้องการการบันทึกข้อมูล")) {
          //alert("ไม่สามารถเบิกได้ เนื่องจากยอดรวม "+this.sum_amtlast+" เกินวงเงินคงเหลือ "+this.limit);        
          console.log('sum_amtlast',this.sum_amtlast,'limit',this.limit);
          this.SendRequese(url);   
        }
      }
      else {
        if(confirm("ยืนยันการบันทึกข้อมูล")) {
          console.log('urlt',url);
          this.SendRequese(url);
        }
      }
    }
    else {
      if (confirm("ยืนยันการบันทึกข้อมูล")) {
        console.log('urlf',url);
        this.SendRequese(url);
      }
    }
  }

  //ส่งบันทึกข้อมูลเบิกปัจจัย
  SendRequese(url: string) {
    axios.post(url).then(res => {
      if (res.data.rowsAffected == 1) {
        this.Formfactor.reset();
        alert("บันทึกข้อมูลเรียบร้อยแล้วค่ะ ^^");  
        this.Loadaskforfactorlist(this.oneplant[0].fmcode);
        this.ck_sum_money_amt(this.oneplant[0].fmcode);
        this.oneplant = [];
        this.cleardata();
      }
      else if (res.data.code) {
        alert("บันทึกข้อมูลไม่สำเร็จกรุณาลองใหม่ ^^");
      }
      else {
        alert("บันทึกข้อมูลไม่สำเร็จกรุณาลองใหม่ ^^");
      }
    }).catch(err => { throw (err) })
  }

  //  clear input
  cleardata() {
    
    this.Change_amt(0);
    this.Formfactor.reset();
    this.Formfactor.get("localstock").setValue('');
/*  this.Formfactor.get("cemecal").setValue(0);
    this.Formfactor.get("fertilizer").setValue(0);
    this.Formfactor.get("dolomite").setValue(0);
    this.Formfactor.get("medical").setValue(0);
    this.Formfactor.get("machine").setValue(0);*/
    this.oneplant = [];
    this.famername = null;
    this.intlandno = null;
    this.main_stock = '';
    this.sum_amtlast = 0;
    this.val_st()
    //$("input[type=number]").val('0');
  }

  fmcode=''
  cancledata(docid: any) {
    let fmcode = this.fmcode //((<HTMLInputElement>document.getElementById("codefm")).value).slice(1, 11);
    let url = "https://asia-southeast2-brr-farmluck.cloudfunctions.net/brdsqlapi/update_getfactor_2?firebaseid=" + docid + "&doc_status=X";
    if (confirm('ต้องยกเลิกรายการนี้ ' + docid + ' ใช่หรือไม่') == true) {
      axios.post(url)
        .then(res => {
          if (res.data.rowsAffected == 1) {
            alert("ยกเลิกเรียบร้อยแล้วค่ะ ^^");
            this.Loadaskforfactorlist(fmcode);
          }
          else if (res.data.code) {
            alert("ยกเลิกไม่สำเร็จกรุณาลองใหม่ ^^");
          }
          else {
            alert("ยกเลิกไม่สำเร็จกรุณาลองใหม่ ^^");
          }
        }).catch(err => { throw (err) })
      this.goloaddata();
    }
    else { }
  }


  ngOnDestroy(): void {
    //Called once, before the instance is destroyed.
    //Add 'implements OnDestroy' to the class.
  /*  this.organicdata = null;
    this.chemicaldata = null;
    this.dolomitedata = null;
    this.machinedata = null;
    this.medicdata = null;*/
    this.stock_data = null;
    this.fertilizerstock = null;
    this.famerlist = null;
    this.dataonefarmer = null;
  }

  /*// ออกใบพิมพ์
  printdoc(year,fmcode, docid) {
    this.router.navigateByUrl("/docfertilizer", { state: {year:'6667', data: fmcode, doc_id: docid } });
  }*/

}
